<template>
  <div class="content contentBody" style="padding: 0; border: 0">
    <div class="search_wrap" style="display: block">
      <el-radio-group class="whd-radio" v-model="formdata.who" @change="radioChange1" size="small"> 
        <el-radio-button label="1">个人佣金</el-radio-button>
        <el-radio-button label="2">员工佣金</el-radio-button>
        <el-radio-button label="3">合伙人佣金</el-radio-button>
      </el-radio-group>      
      <el-form :inline="true" :model="formdata2" class="form-inline" v-if="formdata.who==3">        
        <el-form-item label="合伙人">
          <el-select class="whd-select" clearable v-model="formdata2.partner_id" placeholder="请选择合伙人" size="small">
            <el-option
              v-for="(item) in partner_list"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="formdata2.create_time"
            type="date"
            size="small"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formdata2.act" placeholder="请选择" size="small">
            <el-option
                    v-for="item in items"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formdata" class="form-inline" v-else>        
        <el-form-item label="用户名">
          <el-input v-model="formdata.name" placeholder="请输入用户名" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formdata.phone" placeholder="请输入手机号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="提现时间">
          <el-date-picker
                  v-model="dataTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="small"
                  :picker-options="pickerOptions1"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="佣金打款方式">
          <el-select v-model="formdata.type" placeholder="请选择" size="small">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchList" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="condition" style="margin-top: 0" v-if="formdata.who==1 || formdata.who==2">
        <div class="check_wrap">
          <el-radio-group v-model="formdata.state" @change="radioChange2" size="small">
            <el-radio-button v-for="(item,index) in state_cate" :key="index" :label="item.v">{{item.n}}</el-radio-button>
          </el-radio-group> 
        </div>
        <div class="other_wrap" v-if="formdata.state==1 && tableData.length>0">
          <el-button type="primary" @click="exportfile" size="small">导出</el-button>
        </div>
      </div>       
    </div>
    <div class="table_wrap mt20" v-if="formdata.who==3">
      <el-table :data="tableData2" style="width: 100%">
        <el-table-column prop label type="selection" ></el-table-column>
        <el-table-column prop="partner_name" label="合伙人姓名" width="200"></el-table-column>
        <el-table-column prop="money" label="提现金额"></el-table-column>
        <el-table-column prop="fee" label="提现手续费" width="180"></el-table-column>
        <el-table-column prop="real_money" label="实际到账金额" width="180"></el-table-column>
        <el-table-column prop="status_text" label="处理状态"></el-table-column>
        <el-table-column prop="apply_time_text" label="申请时间"></el-table-column>
        <el-table-column prop="handle_time_text" label="处理时间"></el-table-column> 
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="checkpartner(scope.row.status,scope.row)" v-if="formdata2.status==0">待处理</el-button>
            <el-button type="text" size="small" @click="checkpartner(scope.row.status,scope.row)" v-if="formdata2.status==1">查看凭证</el-button> -->
            <el-button type="text" size="small" @click="checkpartner(scope.row.status,scope.row)">{{scope.row.status==0?'待处理':'查看凭证'}}</el-button>
          </template>         
        </el-table-column> 
      </el-table>
      <div class="pag_wrap" v-if="formdata.who==3">
      <el-pagination
        background
        :page-size="pages.page_size"
        :current-page="pages.current_page"
        layout="total, prev, pager, next"
        :total="pages.total_rows"
        @current-change="pageIndexChange2"
      ></el-pagination>
    </div>
    </div>
    <div class="table_wrap mt20" v-else>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop label type="selection" ></el-table-column>
        <el-table-column prop="create_time" label="提现时间" width="200"></el-table-column>
        <el-table-column prop="user_pic" label="头像" width="120">
          <template slot-scope="scope" v-if="formdata.who==1 || formdata.who==2">
            <div class="td_img">
              <img :src="scope.row.user_pic" alt width="60" height="60"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="user_name" label="申请人" width="180"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="180"></el-table-column>
        <el-table-column prop="money" label="提现金额"></el-table-column>
        <el-table-column prop="money_tax" label="扣税后金额"></el-table-column>
        <el-table-column prop="pay_mode" label="佣金打款方式"></el-table-column>
        <el-table-column label="打款信息" width="250" v-if="formdata.who==1">
          <template slot-scope="scope">
            <template v-if="scope.row.type==0">
              <p>openid: <br/>{{scope.row.openid}}</p>
            </template>
            <template v-else>
              <p>持卡人：{{scope.row.card_holder}}</p>
              <p>开户行：{{scope.row.deposit}}</p>
              <p>银行卡号：{{scope.row.bank_num}}</p>
            </template>
          </template>  
        </el-table-column> 
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="checkemployee('0',scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="checkemployee('1',scope.row)" v-if="formdata.state==0">审核通过</el-button>
            <el-button type="text" size="small" @click="checkemployee('3',scope.row)" v-if="formdata.state==1">修改状态</el-button>
            <el-button type="text" size="small" @click="checkemployee('2',scope.row)" v-if="formdata.state==0 || formdata.state==1">驳回</el-button>
          </template>         
        </el-table-column> 
      </el-table>
      <div class="pag_wrap" v-if="formdata.who==1 || formdata.who==2">
        <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="prev, pager, next"
            :total="page.total"></el-pagination>     
      </div>
    </div>  
    <withdrawalstatus
            :visible.sync="addcheckemployeedialog"
            v-if="employee"
            :whotype="formdata.who"
            :employee="employee"
            @refresh="bindRefresh"
    ></withdrawalstatus>
    <withdrawalDetail 
            :visible.sync="checkWithdrawalDetail"
            :index="formdata.who"
            :employeeId="employeeId"
    ></withdrawalDetail>
    <withdrawalList :visible.sync="withdrawallist" :dialogType="dialogType" :dialogContent="dialogContent"
                    v-if="withdrawallist" @initFn="InitFn"></withdrawalList>      
  </div>
</template>
<script>
  import api from "@/api.js";
  import common from "@/assets/js/common.js";
  import {pagination} from "@/util/util.js";  
  import {yeartime_} from '@/assets/js/common';
  import withdrawalstatus from "@/components/dialog/withdrawalStatus.vue";
  import withdrawalDetail from "@/components/dialog/withdrawalDetail.vue";
  import withdrawalList from "@/components/dialog/withdrawalList.vue";
  export default {
    name: "withdrawalReview",
    components: {
      withdrawalstatus,
      withdrawalDetail,
      withdrawalList,
    },
    data() {
      return {
        formdata: {
          name: "",
          page: 1,
          phone: '',
          start_time: '',
          end_time: '',
          type: 0,
          who: 1,
          state: 0
        },
        partner_list:[],
        formdata2: {
          partner_id: '',
          status: 0,
          create_time:'',
          pages: 1,
          // partner_id: [],
        },
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
          },
        },
        dataTime: [],
        options: [
          {
            value: 0,
            label: "全部"
          },
          {
            value: 1,
            label: "微信零钱"
          },
          {
            value: 2,
            label: "银行卡"
          }],
        items: [
          {
            value: 0,
            label: "全部"
          },
          {
            value: 1,
            label: "已处理"
          },
          {
            value: 2,
            label: "待处理"
          }],
        tableData: [],
        tableData2: [],
        total: 0,
        state_cate: [],
        addcheckemployeedialog: false,
        checkWithdrawalDetail: false,
        withdrawallist: false,
        dialogType: 0,
        dialogContent: null,
        employee: {},
        employeeId: "",
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        pages: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total
      },
      };
    },
    created() {
      this.InitFn();
    },
    methods: {
      // InitFn() {
      //   this.axios
      //       .post(api.withdraw, this.formdata)
      //       .then(response => {
      //         if (response.data.code == 0) {
      //           this.tableData = response.data.list;
      //           this.state_cate = response.data.state_cate;
      //           this.page.total = response.data.all_page;
      //         } else {
      //         }
      //       })
      //       .catch(response => {
      //       });
      // },
      InitFn() {
      let tableObj;
      if (this.formdata.who == 3) {   
        tableObj = this.formdata2;
      } else {
        tableObj = this.formdata;
      }
      // tableObj.page = this.pageDialog.pageindex;
      this.axios   
        .post(this.formdata.who==3?api.partner_withdrawalList:api.withdraw, tableObj)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.state_cate = response.data.state_cate;
            this.page.total = response.data.all_page;
            this.tableData2 = response.data.result.lists;
            this.partner_list = response.data.result.partner_list;
            this.pages = response.data.page;
            
          }
        })
        .catch(() => {});      
    },
      radioChange1(option) {
        this.formdata.page = 1;
        this.formdata.who = option;
        this.InitFn();
      },
      // radioChange1(option) {
      //   if(option==1 || option==2){
      //   this.formdata.page = 1;
      //   this.InitFn();
      //   }else{
      //    this.$router.push({name: "partnerCommission"});
      //   }
        
      // },
      radioChange2(option) {
        this.formdata.page = 1;
        this.formdata.state = option;
        this.InitFn();
      },      
      searchList() {
        this.formdata.page = 1
        if(this.dataTime.length!==0){
          this.formdata.start_time = yeartime_(this.dataTime[0])
          this.formdata.end_time = yeartime_(this.dataTime[1])
        }else{
          this.formdata.start_time = ''
          this.formdata.end_time = ''
        }
        this.InitFn()
      },
      search() {
        this.formdata2.pages = 1
        this.InitFn()
      },
      bindRefresh() {
        this.formdata.page = 1;
        this.formdata.state = 1;
         this.addcheckemployeedialog = false;
        this.InitFn();
      },
      checkemployee(num,option) {
        let that = this
        if (num == 0) {
          //查看
          this.employeeId = option.id;
          this.checkWithdrawalDetail = true;
        } else if (num == 1) {
          //审核通过
          this.$confirm('确认通过?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.axios
              .post(api.companyadmin_withdraw_confirm, {
                withdraw_id: option.id,
                type: 0,
                who: this.formdata.who
              })
              .then(response => {
                if (response.data.code == 0) {
                  that.$message({
                    message: '审核成功!'
                  })
                  that.InitFn()
                } 
              })
              .catch(response => {
              });  
          }).catch(() => {
        
          });        
        } else if (num == 2) {
          //驳回
          that.$prompt('请输入驳回理由','提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }).then(({ value }) => {
            if (value) {
              that.axios
                .post(api.companyadmin_withdraw_confirm, {
                  withdraw_id: option.id,
                  reason: value,
                  type: 1,
                  who: this.formdata.who
                })
                .then(response => {
                  if (response.data.code == 0) {
                    that.$message({
                      message: '已驳回'
                    })
                    this.InitFn();
                  }
                })
                .catch(response => {
                });  
            } else {
              that.$message({
                type: 'warning',
                message: '请输入驳回理由'
              })
            }
          }).catch(() => {

          })
        } else {
          //修改状态
          this.employee = option;
          this.addcheckemployeedialog = true;
        }
      },
      //提现处理
      // checkpartner(option, val) {
      //   this.withdrawallist = true;
      //   this.dialogType = option;
      //   this.dialogContent = val;
      // },
      checkpartner(status, val) {
        this.withdrawallist = true;
        this.dialogContent = val;
        if (status === 1) {
          this.dialogType = 1;
        }else{
          this.dialogType = 0;
        }
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.formdata.page = pageindex;
        this.InitFn();
      }, 
      pageIndexChange2(pageindex2) {
      this.formdata2.pages = pageindex2;
      this.InitFn();
    },    
      // 导出
      exportfile() {    
        this.axios.get(api.companyadmin_withdraw_out_excel,{
          params: this.formdata,
          responseType: "arraybuffer"
        })        
        .then(
          function(response) {
            let filename = "提现信息（待打款）.xlsx";
            this.fileDownload(response.data, filename);
          }.bind(this)
        )
        .catch(
          function(error) {
            
          }.bind(this)
        );
      },
      fileDownload (data, fileName) {
        let blob = new Blob([data], {
          type: "application/octet-stream"
        });
        let filename = fileName || "filename.xls";
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          let blobURL = window.URL.createObjectURL(blob);
          let tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", filename);
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      }
    }
  };
</script>
